import { useEffect, useState } from 'react';
import { ModelDetailType, VehicleImageType } from 'src/modules/newCars/types';
import { TabBar } from 'ui';
// import { AnimatedImage } from 'ui';

import { Header } from '../Header/Header';
import s from './ImageListing.module.scss';

export const ImageListing = ({ images, content }: { images: VehicleImageType, content: ModelDetailType }) => {
  const [activeTab, setActiveTab] = useState(0);
  function getCurrentImage() {
    const tempImages = [];
    if (activeTab === 0) {
      if (images?.exterior?.length) {
        tempImages.push(...images?.exterior);
      }
      if (images?.interior?.length) {
        tempImages.push(...images?.interior);
      }
    } else if (activeTab === 1) {
      if (images?.exterior?.length) {
        tempImages.push(...images.exterior);
      }
    } else if (activeTab === 2) {
      if (images?.interior?.length) {
        tempImages.push(...images.interior);
      }
    }
    return tempImages;
  }
  const [currentImages, setCurrentImages] = useState(getCurrentImage);

  useEffect(() => {
    setCurrentImages(getCurrentImage());
  }, [activeTab]);

  return (
    <div className={s.root}>
      {images?.exterior && images?.interior && (
        <TabBar
          tabItems={['All', 'Exterior', 'Interior']}
          activeTab={activeTab}
          onTabClick={(val) => setActiveTab(val)}
        />
      )}
      <div className={s.gallery}>
        <Header
        content={content}
          images={{
            exterior: currentImages,
            interior: [],
            frontImage: '',
            logo: '',
          }}
        />
      </div>
    </div>
  );
};
